import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { getAuth } from 'firebase/auth';

import { updateDoc, doc } from 'firebase/firestore';

import { ref, uploadBytes } from 'firebase/storage';

import { db, storage } from '../../firebase_config';

import * as yup from 'yup';

import { toast } from 'react-toastify';

export const ProfileUpdateForm = () => {
  const schema = yup
    .object({
      name: yup.string().max(30, 'name is too long'),
      password: yup.string().required('password is a required field').min(6, 'password must be at least 6 characters'),
    })
    .required();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const user = getAuth().currentUser;
  const docRef = doc(db, 'users', user.uid);

  const [photo, setPhoto] = useState(null);

  async function upload(file, user) {
    const fileRef = ref(storage, user.uid + '.png');

    await uploadBytes(fileRef, file);
  }

  const onFileChange = (e) => {
    if (e.target.files[0]) {
      setPhoto(e.target.files[0]);
    }
  };

  const updateUser = (data) => {
    upload(photo, user);
    updateDoc(docRef, { name: data.name }).catch((error) => {
      console.error(error);
    });
    reset();
    toast.success('Success', {
      position: 'top-center',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });
  };

  return (
    <form
      className="my-4 bg-shadow border border-background rounded-lg pt-1 pb-4 px-2 mobile:px-4"
      onSubmit={handleSubmit(updateUser)}>
      <fieldset className="shadow-fieldSet flex flex-col gap-4 mt-2 mobile:mt-1 px-0 py-4 mobile:px-4 duration-300">
        <legend className="border-2 border-background rounded-md shadow-fieldSet text-black text-2xl font-bold ml-2 px-2">
          Update User
        </legend>
        <div className="flex flex-col">
          <input
            type="name"
            id="name"
            placeholder="Type your name"
            className="h-11 w-78 bg-transparent border border-background rounded-3xl py-3 px-7 font-poppins font-normal text-base text-background placeholder:text-background placeholder:font-poppins placeholder:text-base"
            {...register('name', { required: true })}
          />
          <span className="px-4 text-like">{errors.name?.message}</span>
        </div>

        <input
          type="file"
          onChange={onFileChange}
          id="file"
          name="image"
          className="block w-78 font-poppins text-base border border-background rounded-3xl cursor-pointer bg-transparent text-background focus:outline-nonefile:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:bg-background file:text-font hover:file:bg-font hover:file:text-background file:cursor-pointer file:duration-500"
        />
        <div className="flex flex-col">
          <input
            type="password"
            id="Password"
            placeholder="Type password"
            className="h-11 w-78 bg-transparent border border-background rounded-3xl py-3 px-7 font-poppins font-normal text-base text-background placeholder:text-background placeholder:font-poppins placeholder:text-base"
            {...register('password')}
          />
          <span className="px-4 text-like">{errors.password?.message}</span>
        </div>
      </fieldset>
      <button
        type="submit"
        className="cursor-pointer mt-3 p-1 rounded-md h-10 w-full font-semibold text-xl flex justify-center items-center bg-background text-font hover:text-background   hover:bg-font duration-500">
        Update Profile
      </button>
    </form>
  );
};
